import React from 'react';
import LocalFileStorage from '../LocalFileStorage';

type Props = React.ImgHTMLAttributes<HTMLImageElement> & {
	localFileStorage: LocalFileStorage;
	dbKey: IDBValidKey;
};
type State = {
	ready: boolean;
	src: string;
};

class LocalImage extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {
			ready: false,
			src: '',
		};
	}

	async componentDidMount() {
		const { dbKey, localFileStorage } = this.props;

		const src = await localFileStorage.getImageSrc(dbKey);
		this.setState({
			ready: true,
			src,
		});
	}

	async componentDidUpdate(prevProps: Props) {
		const { dbKey, localFileStorage } = this.props;

		if (prevProps.dbKey !== dbKey) {
			const src = await localFileStorage.getImageSrc(dbKey);
			this.setState({
				ready: true,
				src,
			});
		}
	}

	render() {
		const { dbKey, localFileStorage, ...imgProps } = this.props;
		const { ready, src } = this.state;

		if (ready) {
			return (
				<img
					alt=""
					src={src}
					{...imgProps}
				/>
			);
		}

		return (
			<img
				alt=""
				src=""
				{...imgProps}
			/>
		);
	}
}

export default LocalImage;
